import { isEmpty, kebabCase } from 'lodash';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { HonorificBlockTimeItemDataFragment } from '../../../data/types/api/graphql';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { HonorificBlockTimesListItem } from './honorific-block-times-list-item';

type HonorificBlockTimesListProps = {
  loading?: boolean;
  items: HonorificBlockTimeItemDataFragment[];
  onClick?: (value: HonorificBlockTimeItemDataFragment) => void;
};

export function HonorificBlockTimesList({
  loading = false,
  onClick,
  ...props
}: HonorificBlockTimesListProps) {
  const intl = useIntl();

  const items = useMemo(
    () =>
      (props.items ?? [])
        .slice()
        .sort((a, b) =>
          intl
            .formatMessage({ id: `common.honorific.${kebabCase(a.honorific)}` })
            .localeCompare(
              intl.formatMessage({
                id: `common.honorific.${kebabCase(b.honorific)}`,
              })
            )
        ),
    [props.items, intl]
  );

  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }

  return (
    <div className="content-list">
      {items.map(option => (
        <div key={option.honorific} className="content-list__item">
          <HonorificBlockTimesListItem item={option} onClick={onClick} />
        </div>
      ))}
    </div>
  );
}
